import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=f38ef5c4&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38ef5c4')) {
      api.createRecord('f38ef5c4', component.options)
    } else {
      api.reload('f38ef5c4', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=f38ef5c4&", function () {
      api.rerender('f38ef5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/security/user/components/UserForm.vue"
export default component.exports